import m from 'mithril'

export default {
  view: vnode => {
    const morning = require('./morning.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-18-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>

        <h3 className="log-book-text mod-h3">Fra spejder Søren Gregersens dagbog:  </h3>

        <p className="log-book-text">Fredag 9.12.60</p>
        <p className="log-book-text">“Breakfast. I reaktoren blev vi sat til at isolere et “decontamination room”, hvori en person (eller ting) kan blive lukket inde og tage brusebad, hvis han pludselig er blevet udsat for katastrofalt stor bestråling. Dette rum skulle være så lufttæt som overhoved muligt (..)” </p>
        <p className="log-book-text">Fredag 6.01.61</p>
        <p className="log-book-text">“Vi talte en del om reaktorulykken i Idaho, hvor en del af vores reaktorfolk er blevet trænet for kort tid siden (3 mand dræbt)”</p>

        <figure className="log-book-figure">
            <img src={morning} className="log-book-img" />      
            <figcaption className="log-book-figcaption">
            Forside fra avisen Lewiston Morning Tribune, 5. januar 1961.  
            </figcaption>      
          </figure>
          <h3 className="log-book-text mod-h3">USA erkender for høj stråling i Camp Century. Uddrag fra fortrolig rapport, Cold Regions Research and Engineering Laboratory (CRREL):  </h3>
        <p className="log-book-text">"Resultaterne af undersøgelsen bekræftede de tidligere indikationer på, at dosishastighederne i reaktortunnelen var uacceptabelt høje. Desværre forårsagede ugunstige atmosfæriske forhold en radio-blackout straks efter transmission af de første sketchy rapporter om resultaterne af strålingsundersøgelsen. Radio-blackout fortsatte i ti dage, hvor der ikke var kontakt med omverdenen. (..) der skal straks træffes korrigerende foranstaltninger."</p>
    
        </div>
      </div>
    )
  }
}
